import ImageCarousel from 'components/molecules/image-carousel'
import Overlay from 'components/molecules/overlay'
import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components/macro'

const ImageOverlay = styled(Overlay)`
  height: 100vh;
`

const StyledImageCarousel = styled(ImageCarousel)`
  height: 100vh;
`
/* 
  This component is used to display a carousel of images in an overlay.
  It is the same as the LayoutOverlays component, but it can be used with any images.
*/
function GenericImageCarousel({ images, closeImageOverlay, ui }) {
  return (
    <>
      {ui.imageOverlayOpen && (
        <ImageOverlay close={closeImageOverlay}>
          <StyledImageCarousel
            images={ui.carouselImages || images}
            initialSlide={ui.imageOverlayImageIdx}
            fullHeight
            arrows
          />
        </ImageOverlay>
      )}
    </>
  )
}

GenericImageCarousel.propTypes = {
  images: PropTypes.arrayOf(
    PropTypes.shape({
      src: PropTypes.string.isRequired,
      name: PropTypes.string,
      type: PropTypes.string,
    }),
  ).isRequired,
  closeImageOverlay: PropTypes.func.isRequired,
  ui: PropTypes.shape({
    imageOverlayOpen: PropTypes.bool.isRequired,
    imageOverlayImageIdx: PropTypes.number.isRequired,
    carouselImages: PropTypes.array,
  }).isRequired,
}

export default GenericImageCarousel
